"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var core_1 = require("@material-ui/core");
var Icon = function (props) {
    var theme = core_1.useTheme();
    var className = props.className, margin = props.margin, _a = props.size, size = _a === void 0 ? '1rem' : _a, iconClassName = props.iconClassName, iconProps = __rest(props, ["className", "margin", "size", "iconClassName"]);
    return (React.createElement(core_1.Box, { m: margin, className: className },
        React.createElement(react_fontawesome_1.FontAwesomeIcon, __assign({ color: theme.palette.text.secondary, style: { fontSize: size }, className: iconClassName }, iconProps))));
};
exports.default = Icon;
//# sourceMappingURL=Icon.js.map